import { createContext, useEffect, useState } from 'react';
import { getDataFromTurbinePPComposedAssetId } from '../utils/utils';
import { useParams } from 'react-router-dom';

export const ComponentContext = createContext({
  component: null,
  setComponent: () => {},
  asset: null,
  setAsset: () => {},
  latestAssetStatus: null,
  setLatestAssetStatus: () => {},
  isLatestAsset: null,
  refetch: null,
  setRefetch: () => {}
});

function NRComponentContextWrapper({ children }) {
  const { componentId } = useParams();
  const [component, setComponent] = useState(null);
  const [asset, setAsset] = useState(null);
  const [latestAssetStatus, setLatestAssetStatus] = useState(null);
  const [currentAssetStatus, setCurrentAssetStatus] = useState(null);
  const [isLatestAsset, setIsLatestAsset] = useState(null);
  const [refetch, setRefetch] = useState(false);

  // isLatestAsset is only consumed by NRShowAssetStatus (breadcrumb report status).
  // It only affects how that banner decides between "up to date" and "refresh available" without flickering.
  useEffect(() => {
    setIsLatestAsset(null);
    setCurrentAssetStatus(null);
  }, [componentId]);

  useEffect(() => {
    if (!asset?.id || !latestAssetStatus?.assetId || latestAssetStatus.assetId !== componentId) {
      setIsLatestAsset(null);
      return;
    }

    const { assetId: latestStatusAssetId, revision: latestStatusRevision } = getDataFromTurbinePPComposedAssetId(latestAssetStatus.assetId);
    const { assetId: urlAssetId, revision: urlRevision } = getDataFromTurbinePPComposedAssetId(componentId);

    const shouldSyncCurrentStatus = currentAssetStatus?.assetId !== latestAssetStatus.assetId;
    const statusForComparison = shouldSyncCurrentStatus ? latestAssetStatus : currentAssetStatus;

    if (shouldSyncCurrentStatus) {
      setCurrentAssetStatus(latestAssetStatus);
    }

    setIsLatestAsset(
      latestStatusAssetId === urlAssetId &&
        latestStatusRevision === urlRevision &&
        statusForComparison?.lastUpdatedTime == latestAssetStatus?.lastUpdatedTime
    );
  }, [latestAssetStatus, asset, currentAssetStatus, componentId]);

  const defaultValues = {
    component,
    setComponent,
    asset,
    setAsset,
    latestAssetStatus,
    setLatestAssetStatus,
    isLatestAsset,
    refetch,
    setRefetch
  };

  return <ComponentContext.Provider value={defaultValues}>{children}</ComponentContext.Provider>;
}

export default NRComponentContextWrapper;
